
const moment = require("moment-timezone");
export const convertDateFormat = (dateTimeString) => {
  const parsed = moment(dateTimeString, "YYYY-MM-DD HH:mm:ss");
  if (!parsed.isValid()) return "";
  return parsed.format("MMM D, YYYY h:mm A") + " (PST)";
}
